export default __webpack_public_path__ + "static/media/training.480355df.svg";